export const getCardFee = (cardMetadata: {
  cardNetwork: string
  cardType: string
  isRegulated: boolean
}): number => {
  if (cardMetadata?.cardNetwork === 'Amex') {
    return 3.8
  } else if (cardMetadata?.cardType === 'Debit' && cardMetadata?.isRegulated) {
    return 0
  } else {
    return 3.5
  }
}
